import React, {useEffect, useMemo, useState} from 'react'
import clsx from "clsx";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import {
    AddCircleOutline, ExpandLess, ExpandMore, Help,
    RemoveCircleOutline,
} from "@material-ui/icons";
import _ from "lodash";
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors, DragOverlay,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {SortableItem} from './SortableItem';
import {Item} from "./Items";
import {Tooltip} from "@material-ui/core";
import useUserSession from "../../../hooks/useUserSession";
import {DEFAULT_FILTERS} from "./CustomFilters";

const CustomFilterSection = ({section, filters, setFilters, searchValue, addRef, fromAddition, hasChanges, hide}) => {
    const {sectionFilters} = useUserSession()
    const [hideContainer, setHideContainer] = useState(false)
    const [activeId, setActiveId] = useState(null);
    const [tooltipLabel, setTooltipLabel] = useState('')

    useEffect(() => {
        setHideContainer(hide)
    }, [hide])

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleToggleFilter = (filter, add) => {
        const fs = add
            ?
            [...filters[section].filters.filter(f => f.key !== filter.key), {...filter, selected: true}]
            :
            filters[section].filters.map(el => {
                return {...el, selected: el.key === filter.key ? add : !!el?.selected}
            })
        const newSection = {...filters[section], filters: fs}
        const newFilters = {...filters, [section]: {...newSection}}
        setFilters(newFilters)
    }

    const handleSelectAll = () => {
        const newSection = {
            ...filters[section], filters: filters[section].filters.map(el => {
                return {...el, selected: fromAddition}
            })
        }
        const newFilters = {...filters, [section]: {...newSection}}
        setFilters(newFilters)
    }

    const searchedFilters = useMemo(() => {
        let result
        if (!!searchValue) {
            const searchedValue = searchValue.toLowerCase()
            const searchedSection = filters[section].title.toLowerCase().includes(searchedValue)
            result = filters[section].filters.filter(el => el.name.toLowerCase().includes(searchedValue) || searchedSection)
        } else {
            result = filters[section].filters
        }
        if (!fromAddition && !hasChanges) {
            const userFilters = sectionFilters(section, false)
            if (!_.isEmpty(userFilters)) {
                result = result.filter(el => el.selected).sort(
                    (a, b) => userFilters.indexOf(a.key) - userFilters.indexOf(b.key)
                )
            }
        }
        return result
    }, [searchValue, filters])

    function handleDragStart(event) {
        const {active} = event;

        setActiveId(active.id);
    }

    function handleDragEnd(event) {
        const {active, over} = event;

        if (active.id !== over.id) {
            const oldIndex = searchedFilters.findIndex(i => i.key === active.id.replace('_tt', ''));
            const newIndex = searchedFilters.findIndex(i => i.key === over.id.replace('_tt', ''));
            const newOrderSelectedFilters = arrayMove(searchedFilters, oldIndex, newIndex)
            const newOrderSelectedFiltersKeys = newOrderSelectedFilters.map(f => f.key)
            const notSelectedFilters = DEFAULT_FILTERS[section].filters.filter(f => !newOrderSelectedFiltersKeys.includes(f.key))
            const newSectionFilters = [...newOrderSelectedFilters, ...notSelectedFilters]
            const newFilters = {...filters, [section]: {...filters[section], filters: newSectionFilters}}
            setFilters(newFilters)
        }
    }

    const onOpenTooltip = (event) => {
        setTooltipLabel(event.target.offsetWidth < event.target.scrollWidth ? event.target.textContent: '')
    }

    return (
        <React.Fragment>
            {!_.isEmpty(searchedFilters) && !_.isEmpty(searchedFilters.filter(f => !!f && !!f?.selected === !fromAddition)) ?
                <div ref={(node) => addRef(`${filters[section].innerRef}_${!!fromAddition}`, node)}
                     style={{margin: '0 10px 20px 0', width: '100%'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}
                         className={clsx('ria-search-fields-section ria-search-fields-section__title ria-search-fields-section__title--first')}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div>
                                {filters[section].icon}
                            </div>
                            <div>
                                <span style={{fontSize: '18px', fontWeight: '600', color: '#224EDF'}}>{filters[section].title}</span>
                            </div>
                            <div>
                                <span style={{
                                    marginLeft: '15px',
                                    cursor: 'pointer',
                                    color: `${fromAddition ? '#224edf' : '#707070'}`,
                                    fontSize: '14px',
                                    fontWeight: 'normal'
                                }}
                                      className={fromAddition ? '' : 'red-on-hover'}
                                      onClick={() => handleSelectAll()}>
                                {fromAddition ? 'Select All' : 'Remove All'}
                            </span>
                            </div>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div className='zoom' style={{
                                cursor: 'pointer',
                                border: 'solid 1.5px #000',
                                borderRadius: '7px',
                                display: 'flex',
                                padding: '0',
                            }} onClick={() => setHideContainer(!hideContainer)}>
                                {hideContainer ? <ExpandMore style={{height: '20px', width: '20px'}}/> :
                                    <ExpandLess style={{height: '20px', width: '20px'}}/>}
                            </div>
                        </div>
                    </div>
                    {!hideContainer ?
                        <>{section === 'clients' ?
                            <div style={{display: 'flex'}} className={fromAddition ? '' : 'custom-filters-clients'}>
                                <div className="ria-search-fields-section" style={{display: 'block', width: 'calc(50% - 40px)', boxShadow: 'none'}}>
                                    <DndContext
                                        onDragEnd={handleDragEnd}
                                        sensors={sensors}
                                        collisionDetection={closestCenter}
                                        onDragStart={handleDragStart}
                                    ><SortableContext
                                        items={searchedFilters.filter(f => !!f && !!f?.selected === !fromAddition && f.key.includes('(Assets)'))}
                                        strategy={verticalListSortingStrategy}
                                    >
                                        <p style={{color: '#224EDF', fontWeight: '600'}}>Assets by Client</p>
                                        {searchedFilters.filter(f => !!f && !!f?.selected === !fromAddition && f.key.includes('(Assets)')).map((filter, index) =>
                                            <div style={{position: 'relative', marginBottom: '20px'}}>
                                                <SortableItem id={`${filter.key}${filter.tooltip ? '_tt' : ''}`} key={`${filter.key}`} fromAddition={fromAddition}>
                                                    <div onClick={() => fromAddition ? handleToggleFilter(filter, true) : null} className={fromAddition ? 'gray-on-hover' : ''} style={{
                                                        //margin: ' 0 40px 20px 0',
                                                        background: '#9c97970f',
                                                        padding: `${!!fromAddition && !filter.tooltip ? '13px 20px' : '10px 20px'}`,
                                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.06)',
                                                        border: `${!!fromAddition === !!sectionFilters(section, false).includes(filter.key) ? '1px solid #224edf' : ''}`,
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        visibility: `${filter.key === '_' ? 'hidden' : 'unset'}`,
                                                        cursor: `${!!fromAddition ? 'default' : 'grab'}`,
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '10px',
                                                            width: '100%'
                                                        }}>
                                                            {!fromAddition ? <DragIndicatorIcon style={{color: '#959595'}}/> : null}
                                                            <Tooltip onOpen={onOpenTooltip} title={tooltipLabel}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '300',
                                                                    color: '#000',
                                                                    width: 'calc(100% - 68px)',
                                                                    whiteSpace: 'nowrap',
                                                                    textOverflow: 'ellipsis',
                                                                    overflow: 'hidden',
                                                                }}>{filter.name}</span>
                                                            </Tooltip>
                                                            {filter.tooltip ? <Tooltip
                                                                title={filter.tooltip}>
                                                                <Help className='help-tt-icon'/>
                                                            </Tooltip> : null}
                                                        </div>
                                                        {!!filter?.selected ?
                                                            <RemoveCircleOutline
                                                                className='red-on-hover'
                                                                style={{
                                                                    visibility: 'hidden',
                                                                    color: '#e2e2e2',
                                                                    cursor: 'pointer'
                                                                }} onClick={() => handleToggleFilter(filter, false)}/> :
                                                            <AddCircleOutline style={{
                                                                position: 'absolute',
                                                                right: '20px',
                                                                top: '10px',
                                                                color: '#224edf',
                                                                cursor: 'pointer'
                                                            }}/>
                                                        }
                                                    </div>
                                                </SortableItem>
                                                {!!filter?.selected ?
                                                    <RemoveCircleOutline
                                                        className='red-on-hover'
                                                        style={{
                                                            position: 'absolute',
                                                            right: '20px',
                                                            top: '10px',
                                                            color: '#e2e2e2',
                                                            cursor: 'pointer'
                                                        }} onClick={() => handleToggleFilter(filter, false)}/> :
                                                    null
                                                }
                                            </div>
                                        )}
                                        <DragOverlay>
                                            {activeId ? <Item id={activeId}>
                                                <div style={{
                                                    //margin: ' 0 40px 20px 0',
                                                    padding: `${!!fromAddition ? '13px 20px' : '10px 20px'}`,
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.06)',
                                                    backgroundColor: '#9c97970f',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    cursor: 'grabbing'
                                                }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        width: '100%'
                                                    }}>
                                                        {!fromAddition ? <DragIndicatorIcon style={{color: '#959595'}}/> : null}
                                                        <span style={{
                                                            fontSize: '14px',
                                                            fontWeight: '300',
                                                            color: '#000',
                                                            width: 'calc(100% - 68px)',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden',
                                                        }}>{activeId.replace('_tt', '')}</span>
                                                        {activeId.includes('_tt') ? <Tooltip
                                                            title={'...'}>
                                                            <Help className='help-tt-icon'/>
                                                        </Tooltip> : null}
                                                    </div>
                                                    {!fromAddition ?
                                                        <RemoveCircleOutline
                                                            className='red-on-hover'
                                                            style={{color: '#e2e2e2', cursor: 'pointer', marginLeft: '-24px'}}
                                                            onClick={() => null}/> :
                                                        <AddCircleOutline style={{color: '#224edf', cursor: 'pointer'}}
                                                                          onClick={() => null}/>
                                                    }
                                                </div>
                                            </Item> : null}
                                        </DragOverlay>
                                    </SortableContext>
                                    </DndContext>
                                </div>
                                <div className="ria-search-fields-section" style={{display: 'block', width: 'calc(50% - 40px)', boxShadow: 'none'}}>
                                    <DndContext
                                        onDragEnd={handleDragEnd}
                                        sensors={sensors}
                                        collisionDetection={closestCenter}
                                        onDragStart={handleDragStart}
                                    ><SortableContext
                                        items={searchedFilters.filter(f => !!f && !!f?.selected === !fromAddition && f.key.includes('(Clients)'))}
                                        strategy={verticalListSortingStrategy}
                                    >
                                        <p style={{color: '#224EDF', fontWeight: '600'}}>Total Clients</p>
                                        {searchedFilters.filter(f => !!f && !!f?.selected === !fromAddition && f.key.includes('(Clients)')).map((filter, index) =>
                                            <div style={{position: 'relative', marginBottom: '20px'}}>
                                                <SortableItem id={`${filter.key}${filter.tooltip ? '_tt' : ''}`} key={`${filter.key}`} fromAddition={fromAddition}>
                                                    <div onClick={() => fromAddition ? handleToggleFilter(filter, true) : null} className={fromAddition ? 'gray-on-hover' : ''} style={{
                                                        //margin: ' 0 40px 20px 0',
                                                        padding: `${!!fromAddition && !filter.tooltip ? '13px 20px' : '10px 20px'}`,
                                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.06)',
                                                        border: `${!!fromAddition === !!sectionFilters(section, false).includes(filter.key) ? '1px solid #224edf' : ''}`,
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        background: '#9c97970f',
                                                        visibility: `${filter.key === '_' ? 'hidden' : 'unset'}`,
                                                        cursor: `${!!fromAddition ? 'default' : 'grab'}`,
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '10px',
                                                            width: '100%'
                                                        }}>
                                                            {!fromAddition ? <DragIndicatorIcon style={{color: '#959595'}}/> : null}
                                                            <Tooltip onOpen={onOpenTooltip} title={tooltipLabel}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '300',
                                                                    color: '#000',
                                                                    width: 'calc(100% - 68px)',
                                                                    whiteSpace: 'nowrap',
                                                                    textOverflow: 'ellipsis',
                                                                    overflow: 'hidden',
                                                                }}>{filter.name}</span>
                                                            </Tooltip>
                                                            {filter.tooltip ? <Tooltip
                                                                title={filter.tooltip}>
                                                                <Help className='help-tt-icon'/>
                                                            </Tooltip> : null}
                                                        </div>
                                                        {!!filter?.selected ?
                                                            <RemoveCircleOutline
                                                                className='red-on-hover'
                                                                style={{
                                                                    visibility: 'hidden',
                                                                    color: '#e2e2e2',
                                                                    cursor: 'pointer'
                                                                }} onClick={() => handleToggleFilter(filter, false)}/> :
                                                            <AddCircleOutline style={{
                                                                position: 'absolute',
                                                                right: '20px',
                                                                top: '10px',
                                                                color: '#224edf',
                                                                cursor: 'pointer'
                                                            }}/>
                                                        }
                                                    </div>
                                                </SortableItem>
                                                {!!filter?.selected ?
                                                    <RemoveCircleOutline
                                                        className='red-on-hover'
                                                        style={{
                                                            position: 'absolute',
                                                            right: '20px',
                                                            top: '10px',
                                                            color: '#e2e2e2',
                                                            cursor: 'pointer'
                                                        }} onClick={() => handleToggleFilter(filter, false)}/> :
                                                    null
                                                }
                                            </div>
                                        )}
                                        <DragOverlay>
                                            {activeId ? <Item id={activeId}>
                                                <div style={{
                                                    //margin: ' 0 40px 20px 0',
                                                    padding: `${!!fromAddition ? '13px 20px' : '10px 20px'}`,
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.06)',
                                                    backgroundColor: '#9c97970f',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    cursor: 'grabbing'
                                                }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        width: '100%'
                                                    }}>
                                                        {!fromAddition ? <DragIndicatorIcon style={{color: '#959595'}}/> : null}
                                                        <span style={{
                                                            fontSize: '14px',
                                                            fontWeight: '300',
                                                            color: '#000',
                                                            width: 'calc(100% - 68px)',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden',
                                                        }}>{activeId.replace('_tt', '')}</span>
                                                        {activeId.includes('_tt') ? <Tooltip
                                                            title={'...'}>
                                                            <Help className='help-tt-icon'/>
                                                        </Tooltip> : null}
                                                    </div>
                                                    {!fromAddition ?
                                                        <RemoveCircleOutline
                                                            className='red-on-hover'
                                                            style={{color: '#e2e2e2', cursor: 'pointer', marginLeft: '-24px'}}
                                                            onClick={() => null}/> :
                                                        <AddCircleOutline style={{color: '#224edf', cursor: 'pointer'}}
                                                                          onClick={() => null}/>
                                                    }
                                                </div>
                                            </Item> : null}
                                        </DragOverlay>
                                    </SortableContext>
                                    </DndContext>
                                </div>
                           </div>
                            :
                            <div className="ria-search-fields-section" style={fromAddition ? {gridTemplateColumns: 'repeat(2, 1fr)'} : {}}>
                                <DndContext
                                    onDragEnd={handleDragEnd}
                                    sensors={sensors}
                                    collisionDetection={closestCenter}
                                    onDragStart={handleDragStart}
                                ><SortableContext
                                    items={searchedFilters.filter(f => !!f && !!f?.selected === !fromAddition)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    {searchedFilters.filter(f => !!f && !!f?.selected === !fromAddition).map((filter, index) =>
                                        <>{filter.key === '_title_' ?
                                            <p style={{color: '#224EDF', fontWeight: '600'}}>{filter.name}</p>
                                            :
                                            <div style={{position: 'relative'}}>
                                                <SortableItem id={`${filter.key}${filter.tooltip ? '_tt' : ''}`} key={`${filter.key}`} fromAddition={fromAddition}>
                                                    <div onClick={() => fromAddition ? handleToggleFilter(filter, true) : null} className={fromAddition ? 'gray-on-hover' : ''} style={{
                                                        //margin: ' 0 40px 20px 0',
                                                        padding: `${!!fromAddition && !filter.tooltip ? '13px 20px' : '10px 20px'}`,
                                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.06)',
                                                        border: `${!!fromAddition === !!sectionFilters(section, false).includes(filter.key) ? '1px solid #224edf' : ''}`,
                                                        backgroundColor: '#9c97970f',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        visibility: `${filter.key === '_' ? 'hidden' : 'unset'}`,
                                                        cursor: `${!!fromAddition ? 'default' : 'grab'}`,
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '10px',
                                                            width: 'calc(100% - 44px)'
                                                        }}>
                                                            {!fromAddition ? <DragIndicatorIcon style={{color: '#959595'}}/> : null}
                                                            <Tooltip onOpen={onOpenTooltip} title={tooltipLabel}>
                                                                <span style={{
                                                                    fontSize: '14px',
                                                                    fontWeight: '300',
                                                                    color: '#000',
                                                                }}>{filter.name}</span>
                                                            </Tooltip>
                                                            {filter.tooltip ? <Tooltip
                                                                title={filter.tooltip}>
                                                                <Help className='help-tt-icon'/>
                                                            </Tooltip> : null}
                                                        </div>
                                                        {!!filter?.selected ?
                                                            <RemoveCircleOutline
                                                                className='red-on-hover'
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '20px',
                                                                    top: '10px',
                                                                    color: '#e2e2e2',
                                                                    cursor: 'pointer'
                                                                }} onClick={() => handleToggleFilter(filter, false)}/> :
                                                            <AddCircleOutline style={{
                                                                position: 'absolute',
                                                                right: '20px',
                                                                top: '10px',
                                                                color: '#224edf',
                                                                cursor: 'pointer'
                                                            }}/>
                                                        }
                                                    </div>
                                                </SortableItem>
                                                {!!filter?.selected ?
                                                    <RemoveCircleOutline
                                                        className='red-on-hover'
                                                        style={{
                                                            position: 'absolute',
                                                            right: '20px',
                                                            top: '10px',
                                                            color: '#e2e2e2',
                                                            cursor: 'pointer'
                                                        }} onClick={() => handleToggleFilter(filter, false)}/> :
                                                    null
                                                }
                                            </div>
                                        }</>
                                    )}
                                    <DragOverlay>
                                        {activeId ? <Item id={activeId}>
                                            <div style={{
                                                //margin: ' 0 40px 20px 0',
                                                padding: `${!!fromAddition ? '13px 20px' : '10px 20px'}`,
                                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.06)',
                                                backgroundColor: '#9c97970f',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                cursor: 'grabbing'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    width: 'calc(100% - 44px)'
                                                }}>
                                                    {!fromAddition ? <DragIndicatorIcon style={{color: '#959595'}}/> : null}
                                                    <span style={{
                                                        fontSize: '14px',
                                                        fontWeight: '300',
                                                        color: '#000',
                                                    }}>{activeId.replace('_tt', '')}</span>
                                                    {activeId.includes('_tt') ? <Tooltip
                                                        title={'...'}>
                                                        <Help className='help-tt-icon'/>
                                                    </Tooltip> : null}
                                                </div>
                                                {!fromAddition ?
                                                    <RemoveCircleOutline
                                                        className='red-on-hover'
                                                        style={{color: '#e2e2e2', cursor: 'pointer'}}
                                                        onClick={() => null}/> :
                                                    <AddCircleOutline style={{color: '#224edf', cursor: 'pointer'}}
                                                                      onClick={() => null}/>
                                                }
                                            </div>
                                        </Item> : null}
                                    </DragOverlay>
                                </SortableContext>
                                </DndContext>
                            </div>
                        }</>
                        : null
                    }
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default CustomFilterSection